import { Box } from "@mui/material";
import DynamicTable from "../../../../data/DynamicTable/dynamicTable";

import { useEffect, useState } from "react";
import { fetchDataEngine } from "../../../../data/Axios/DynamicService";

import {
  imprestApplicationsByUser,
  leaveApplications,
  leaveApplicationsByUser,
} from "../../../../data/Queries/HRmanagement/leavemanagement";
import {
  LeaveApplicationsColumns,
  imprestApplicationsColumns,
} from "../../../../data/Columns/hrmanagement";
import { HRService } from "../../../../config";

import { pettyCashApplications } from "../../../../data/Queries/HRmanagement/leavemanagement";

const base_url = HRService.uri;
const actions = {
  entity: "My Imprest Applications",
  isSubRight: true,
  edit: {
    key: "EDIT",
    button_name: "Edit",
    Show_Button: false,
    permission: "EditPermission",
  },
  add: {
    key: "ADD",
    button_name: "Add",
    Show_Button: false,
    permission: "CreatePermission",
  },
  activateDeactivate: {
    key: "ACTIVATEDEACTIVATE",
    button_name: "Deactivate",
    Show_Button: false,
    permission: "ActivatePermission",
  },

  AssignTask: {
    key: "ASSIGN_TASK",
    button_name: "Assign Task",
    Show_Button: false,
    permission: "hasNoPermission",
    roleGroupId: [1, 2, 3, 4],
  },

  showStatus: true,
};
function PCApplicationsTable() {
  return (
    <Box m="2px">
      <>
        <DynamicTable
          title=" Petty Cash Applications"
          subtitle="View all petty cash Apllications"
          columns={imprestApplicationsColumns}
          //FormComponent={ImprestApplicationForm}
          query={pettyCashApplications}
          actions={actions}
          base_url={base_url}
        />
      </>
    </Box>
  );
}

export default PCApplicationsTable;
